<template lang="pug">
  v-list
    v-list-item
      v-list-item-avatar(
        v-shared-element:[heroIdPublishAvatar]="{ includeChildren: true, ignoreTransparency: true }")
        feature-avatar(:src="$get(routeState.me, 'image.src')")
      v-list-item-content
        v-list-item-title {{ $get(routeState.me, 'name') }}
</template>

<script>
import { injectRouteState } from '@iez/core'
import { computed } from '@vue/composition-api'
import { routeCurrent } from '@iez/core/router'

export default {
  setup () {
    const routeState = injectRouteState()

    return {
      routeState,
      heroIdPublishAvatar: computed(() => routeCurrent.query.heroIdPublishAvatar)
    }
  }
}
</script>
